import { Directive, Input } from '@angular/core';
import { MatMenuPanel, MatMenuTrigger } from '@angular/material/menu';

/**
 * A simple extension of [[MatMenuTrigger]] that does not handle click events
 * This allows programatic control over menus
 */
@Directive({
  selector: `[sgNavMenuTriggerFor]`,
  host: {
    'aria-haspopup': 'true',
  },
  exportAs: 'sgNavMenuTrigger',
  standalone: false,
})
export class SgNavMenuTrigger extends MatMenuTrigger {
  @Input('sgNavMenuTriggerFor') get menu(): MatMenuPanel {
    return super.menu;
  }
  set menu(value: MatMenuPanel) {
    super.menu = value;
  }
}
